import { observer } from 'mobx-react-lite'
import {
  EditScopeChangeInventoryItem,
  ScopeChangeEditInventoryItemsDialog,
} from '@/features/admin/scope-change-requests/ScopeChangeEditInventoryItemsDialog'
import { AddInventoryItemsToEditDialogContainer } from '@/features/admin/scope-change-requests/AddInventoryItemsToEditDialog/AddInventoryItemsToEditDialogContainer'
import {
  type ScopeChangeEditInventoryItemsDialogViewModel,
  type EditScopeChangeInventoryItemViewModel,
} from './ScopeChangeEditInventoryItemsDialogViewModel'

export interface ScopeChangeEditInventoryItemsDialogContainerProps {
  vm: ScopeChangeEditInventoryItemsDialogViewModel
}

export const ScopeChangeEditInventoryItemsDialogContainer = observer(
  function ScopeChangeEditInventoryItemsDialogContainer({
    vm,
  }: ScopeChangeEditInventoryItemsDialogContainerProps) {
    return (
      <ScopeChangeEditInventoryItemsDialog
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        onAddItems={vm.showAddItems}
        onSave={vm.save}
        isSavePending={vm.save.pending}
        addItemsDialog={
          <AddInventoryItemsToEditDialogContainer
            vm={vm.addInventoryItemsToEditDialogVm}
          />
        }
      >
        {vm.editScopeChangeInventoryItems.map((item) => {
          return (
            <EditScopeChangeInventoryItemContainer
              key={item.key}
              item={item}
              onRemove={() => vm.removeScopeChange(item.versionId)}
            />
          )
        })}
      </ScopeChangeEditInventoryItemsDialog>
    )
  },
)

interface EditScopeChangeInventoryItemContainerProps {
  item: EditScopeChangeInventoryItemViewModel
  onRemove: () => void
}

const EditScopeChangeInventoryItemContainer = observer(
  function EditScopeChangeInventoryItemContainer({
    item,
    onRemove,
  }: EditScopeChangeInventoryItemContainerProps) {
    return (
      <EditScopeChangeInventoryItem
        versionId={item.versionId}
        name={item.name}
        currentQuantity={item.currentQuantity}
        newQuantity={item.newQuantity}
        newQuantityError={item.validation.getError('newQuantity')}
        onQuantityChange={item.setQuantity}
        onIncrementQuantity={item.incrementQuantity}
        onDecrementQuantity={item.decrementQuantity}
        onRemove={onRemove}
      />
    )
  },
)
